/**
 * Pre-compiled en messages for MoneyInput
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  amountInputLabel: `Amount`,
  currencySelectLabel: `Currency`,
  highPrecisionPrice: `High precision price`,
};
